import { useQuery, useMutation } from "@tanstack/react-query";
import { UpdateScheduledNotificationRequest } from "../types/api/notifications";
import {
  fetchScheduledNotifications,
  createScheduledNotification,
  updateScheduledNotification,
  sendScheduledNotification,
  deleteScheduledNotifications,
} from "../services/notifications";

export const useScheduledNotificationsQuery = (
  is_canceled: boolean | undefined,
  is_sent: boolean | undefined,
  planned_dt_from: string | undefined,
  planned_dt_to: string | undefined,
  search: string | undefined,
  page: number,
  limit: number,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: [
      "scheduled-notifications",
      is_canceled,
      is_sent,
      planned_dt_from,
      planned_dt_to,
      search,
      page,
      limit,
    ],
    queryFn: () =>
      fetchScheduledNotifications({
        is_canceled,
        is_sent,
        planned_dt_from,
        planned_dt_to,
        search,
        limit,
        offset: (page - 1) * limit,
      }),
    retry: 0,
    enabled: options?.enabled ?? true,
  });
};

export const useCreateScheduledNotificationMutation = () => {
  return useMutation({
    mutationFn: createScheduledNotification,
  });
};

export const useUpdateScheduledNotificationMutation = () => {
  return useMutation({
    mutationFn: ({
      notificationId,
      data,
    }: {
      notificationId: string;
      data: UpdateScheduledNotificationRequest;
    }) => updateScheduledNotification(notificationId, data),
  });
};

export const useSendScheduledNotificationMutation = () => {
  return useMutation({
    mutationFn: sendScheduledNotification,
  });
};

export const useDeleteScheduledNotificationsMutation = () => {
  return useMutation({
    mutationFn: deleteScheduledNotifications,
  });
};
